import Vue from 'vue'
import SlRow from '../includes/sl-row'
import SlColumn from '../includes/sl-column'

import SlShowBox from '../includes/sl-show-box'
import SlBox from '../includes/sl-box'
import SlSwitcher from '../includes/sl-switcher'
import SlSpPage from '../includes/sl-sp-page'
import SlBtn from '../includes/sl-btn'
import SlA from '../includes/sl-a'

Vue.component('row', SlRow)
Vue.component('column', SlColumn)

Vue.component('sl-box', SlBox)
Vue.component('sl-show-box', SlShowBox)
Vue.component('sl-switcher', SlSwitcher)
Vue.component('sl-sp-page', SlSpPage)
Vue.component('sl-btn', SlBtn)
Vue.component('sl-a', SlA)



// WEBPACK FOOTER //
// ./src/lib/global.js